import { AfterViewInit, Component, ElementRef, ViewChild, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { Store } from '@ngxs/store';
import { LogoutStart } from '../../actions/auth-actions';
import { GoogleAnalyticsService } from 'src/modules/analytics/services/google-analytics.service';
import { AnalyticsEventName } from 'src/modules/analytics/models/analytics-event-name.enum';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  imports: [FormsModule]
})
export class LogoutComponent implements AfterViewInit {
  private readonly store = inject(Store);
  private readonly analyticsService = inject(GoogleAnalyticsService);

  public readonly logoutUrl = `${environment.apiUrl}${environment.logoutUrlSuffix}`;
  @ViewChild('logoutForm') public form!: ElementRef;

  public ngAfterViewInit(): void {
    this.analyticsService.trackEvent(AnalyticsEventName.SessionManualLogout);
    this.store.dispatch(new LogoutStart());
    this.form.nativeElement.submit();
  }
}
